import { motion } from "framer-motion";

const MASK_HIDDEN = { y: "110%" };
const MASK_SHOWN = { y: "0%" };
const MASK_EASE = [0.76, 0, 0.24, 1];
const BLOCK_STYLE = { display: "block" };
const REVEAL_SHOWN = { opacity: 1, y: 0 };
const REVEAL_VIEWPORT = { once: true, margin: "-80px" };
const REVEAL_EASE = [0.22, 1, 0.36, 1];

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`line-mask ${className}`}>
    <motion.span
      initial={MASK_HIDDEN}
      animate={MASK_SHOWN}
      transition={{ duration: 1.1, delay, ease: MASK_EASE }}
      style={BLOCK_STYLE}
    >
      {children}
    </motion.span>
  </span>
);

export const ScrollReveal = ({ children, y = 32, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={REVEAL_SHOWN}
    viewport={REVEAL_VIEWPORT}
    transition={{ duration: 1, delay, ease: REVEAL_EASE }}
    className={className}
  >
    {children}
  </motion.div>
);
